// extracted by mini-css-extract-plugin
export default {"wrapper":"BF","content":"CF","firstSection":"EF","text":"FF","table":"GF","tableText":"HF","row":"IF","column_2":"JF","column_1":"KF","column_3":"LF"};
    if(module.hot) {
      // 1721922364409
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  